import { getHeaderHtml } from "./headerUtil";

export const getReportHeader = (hospitalData, reportTitle) => {
  return `
    <div class="header">
      ${getHeaderHtml(hospitalData)}
      <div class="report-title">${reportTitle}</div>
    </div>
  `;
};

export const getReportStyles = (pageSize = "a4", orientation = "portrait") => {
  return `
    @page { 
      size: ${pageSize} ${orientation}; 
      margin: 10mm; 
    }
    body { 
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
      padding: 20px; 
      color: #333; 
      background: #fff !important;
    }
    .header { text-align: center; margin-bottom: 25px; }
    .hospital-name { font-size: 28px; font-weight: bold; color: #006d77; margin-bottom: 5px; text-transform: uppercase; }
    .hospital-info { font-size: 14px; color: #555; font-weight: 500; }
    .report-title { font-size: 22px; font-weight: bold; margin-top: 10px; text-transform: uppercase; color: #334155; letter-spacing: 1px; }
    .meta-info { display: flex; justify-content: space-between; margin-bottom: 20px; font-size: 14px; color: #1e293b; border-bottom: 1px dashed #ccc; padding-bottom: 10px; }
    table { width: 100%; border-collapse: collapse !important; border: 1px solid #dee2e6 !important; margin-top: 10px; }
    th { background-color: #f1f5f9 !important; color: #334155 !important; padding: 12px 8px !important; text-align: center !important; font-size: 14px; border: 1px solid #cbd5e1 !important; text-transform: uppercase; }
    td { padding: 10px 8px !important; border: 1px solid #dee2e6 !important; font-size: 12px; vertical-align: middle !important; text-align: center; color: #000; }
    tr:nth-child(even) { background-color: #f8fafc !important; }
    tfoot tr td { background-color: #f1f5f9 !important; font-weight: bold !important; border-top: 2px solid #334155 !important; color: #000 !important; font-size: 14px; }
    .footer { display: none; }
    @media print { 
      .no-print { display: none !important; } 
      body { padding: 0; margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .header { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  `;
};
